import { Collapse } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import type { AppConfigsFormJson } from "src/app/features/ApplicationConfigurations/types/AppConfigsTypes";
import { ApplicationConfigurationsForm } from "./ApplicationConfigurationsForm";

export interface ApplicationConfigurationsProps {
    value: AppConfigsFormJson;
}

export const ApplicationConfigurations: FC<ApplicationConfigurationsProps> = ({ value }) => {
    const { Panel } = Collapse;

    const renderPanels = (data: AppConfigsFormJson) => {
        const dataArray = Array.isArray(data) ? data : []; // Ensure data is always an array
        return dataArray.map((dataItem) => {
            if (dataItem.configTabs?.length === 0) return null; // Skip rendering if there are no tabs

            const showArrow = !!dataItem.configTabs?.length;
            return (
                <Collapse key={`${dataItem.key}-renderCollapse`}>
                    <Panel header={i18n.t(`form.${dataItem.header}`)} key={`${dataItem.key}-renderPanel`} showArrow={showArrow}>
                        <ApplicationConfigurationsForm appConfigsFormData={dataItem} />
                    </Panel>
                </Collapse>
            );
        });
    };

    return <Collapse>{renderPanels(value || [])}</Collapse>;
};
